export default "__VITE_ASSET__vUWZOZbe__"